import { createAdminMode, useAdminMode as useSharedAdminMode, useSession, type AdminModeState } from "@jkast90/kast-common/auth";
import { ADMIN_GROUPS } from "../auth/session";

// Admin tools are on for admins (kast-common's admin mode): the admin
// groups get the Admin link and the admin-only bits elsewhere, and can turn
// them off with the "Admin tools" switch (Profile, and About's
// Preferences), on this device, to use CloudBoy as a player does. The
// stored switch never grants on its own: without the group it does
// nothing. Groups match exactly, as Cognito has them (play-api ignores
// case; no differently-cased group exists).
//
// This only decides what to show. play-api checks the group on every admin
// route, so the switch is a safety catch against stray taps, not a boundary.
// It stays on this device; it isn't one of the settings that follow the account.
export const ADMIN_MODE_KEY = "pocket-play.adminMode";

/** The switch. `adminMode.isOn(user)` for code outside React (the crash screen). */
export const adminMode = createAdminMode({ admin: ADMIN_GROUPS, storageKey: ADMIN_MODE_KEY });

/** Admin mode for the signed-in account. */
export function useAdminMode(): AdminModeState {
  return useSharedAdminMode(adminMode, useSession());
}
